/*
  Omnify location lines (2026-09-23).
  - Products with the metafield omnify.location_prompt render a required "Location" line property
    (snippets/omnify-location-field.liquid). The theme form is novalidate, so this script blocks the add to cart
    until a location is typed, and keeps the quantity at 1 (one location per line).
  - Optional upsell checkbox on Add a Location: adds Add a Location and Location Monitoring (on its selling plan)
    with the same location in one /cart/add.js call, then opens the cart drawer.
  - Cart suggestion buttons ([data-omnify-add-monitoring], snippets/omnify-location-upsell.liquid).
*/
(function () {
  'use strict';
  if (window.OmnifyLocation) return;
  var EMPTY_MSG = 'Please enter the location, for example Knoxville, TN.';

  function blockFor(form) {
    return form && form.querySelector ? form.querySelector('[data-omnify-location-block]') : null;
  }

  function setError(block, msg) {
    var e = block.querySelector('.omnify-location__error');
    var i = block.querySelector('[data-omnify-location]');
    if (e) {
      e.textContent = msg || EMPTY_MSG;
      e.hidden = !msg;
    }
    if (i) i.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
        return d;
      });
    });
  }

  function showCart() {
    var fee = window.OmnifySetupFee;
    var drawer = document.querySelector('cart-drawer');
    var p = fee && typeof fee.refresh === 'function' ? fee.refresh() : Promise.resolve();
    return p.then(function () {
      if (drawer && typeof drawer.open === 'function') {
        drawer.classList.remove('is-empty');
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  document.addEventListener(
    'input',
    function (evt) {
      var t = evt.target;
      if (t && t.matches && t.matches('[data-omnify-location]') && t.value.trim()) {
        var block = t.closest('[data-omnify-location-block]');
        if (block) setError(block, null);
      }
    },
    true
  );

  // Capture phase: runs before the theme's product-form submit handler.
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      var block = blockFor(form);
      if (!block) return;
      var input = block.querySelector('[data-omnify-location]');
      var val = String((input && input.value) || '').replace(/\s+/g, ' ').trim();
      if (val.length < 2) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        setError(block, EMPTY_MSG);
        if (input) input.focus();
        return;
      }
      input.value = val;
      setError(block, null);
      var qty = (form.id && document.querySelector('input[name="quantity"][form="' + form.id + '"]')) || form.querySelector('input[name="quantity"]');
      if (qty) qty.value = 1;

      var up = block.querySelector('[data-omnify-upsell]');
      if (!up || !up.checked) return; // normal theme add, the Location property rides along in the form

      evt.preventDefault();
      evt.stopImmediatePropagation();
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }
      var props = { Location: val };
      var items = [{ id: Number(idInput.value), quantity: 1, properties: props }];
      var mon = { id: Number(up.getAttribute('data-variant')), quantity: 1, properties: props };
      if (up.getAttribute('data-plan')) mon.selling_plan = Number(up.getAttribute('data-plan'));
      items.push(mon);
      post('/cart/add.js', { items: items })
        .then(function () {
          input.value = '';
          up.checked = false;
          return showCart();
        })
        .catch(function (err) {
          setError(block, (err && err.message) || 'Could not add to cart.');
        })
        .then(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          }
        });
    },
    true
  );

  document.addEventListener('click', function (evt) {
    var b = evt.target && evt.target.closest ? evt.target.closest('[data-omnify-add-monitoring]') : null;
    if (!b) return;
    evt.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    var item = { id: Number(b.getAttribute('data-variant')), quantity: 1, properties: { Location: b.getAttribute('data-location') || '' } };
    if (b.getAttribute('data-plan')) item.selling_plan = Number(b.getAttribute('data-plan'));
    var inDrawer = !!b.closest('#CartDrawer, cart-drawer');
    post('/cart/add.js', { items: [item] })
      .then(function () {
        if (inDrawer && window.OmnifySetupFee && typeof window.OmnifySetupFee.refresh === 'function') return window.OmnifySetupFee.refresh();
        window.location.reload();
      })
      .catch(function () {
        b.disabled = false;
      });
  });

  window.OmnifyLocation = { version: '2026-09-23' };
})();
